import { render } from "./RecentLeads.vue?vue&type=template&id=4f0ed9c3&ts=true"
import script from "./RecentLeads.vue?vue&type=script&lang=ts"
export * from "./RecentLeads.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__